<template>
  <SupplierHeader
    class="product-content__header"
    @search="onSearch"
    :factory-id="detailInfo?.sellerOpenId"
  />
  <PageContainer
    class="product-content"
  >
    <Skeleton v-if="showSkeleton" />
    <div
      v-else
      ref="containRef"
      class="content-wrapper"
    >
      <div class="content-wrapper-left">
        <div class="top">
          <div
            class="carousel-wrapper"
          >
            <Carousel
              ref="carouselRef"
              :title="detailInfo?.subjectTrans"
              :swiper-images="swiperImages"
              :product-image-length="productImages.length"
            />
          </div>
          <Information
            ref="infoRef"
            @update-carousel="handleUpdateCarousel"
            @calc-ship-fee="handleCalcShipFee"
            @has-processing="judgeProcessing"
            :detail-info="detailInfo"
          />
        </div>
        <DetailInfo
          v-if="detailInfo"
          :detail-info="detailInfo"
          :description-images="descriptionImages"
        />
      </div>

      <div class="fixed-info">
        <Summary
          @add-cart-success="onAddCartSuccess"
          :has-processing="isProcessing"
          :list="selectedSkuList"
          :min-order-quantity="detailInfo?.minOrderQuantity"
        />
      </div>
    </div>
    <FactoryRecommend
      v-if="detailInfo"
      :factory-id="detailInfo.sellerOpenId"
    />
    <OfferImagePreview
      v-if="detailInfo"
      :title="detailInfo.subjectTrans"
      :main-images="productImages"
      :variant-images="variantImages"
      :description-images="descriptionImages"
      @find-similar="onFindSimilar"
    />
  </PageContainer>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { buriedPointUtil, formatName, gaAnalytics, openURLWithChannelQuery, waitForIntercom } from '@/utils/utils'
import Skeleton from './components/Skeleton.vue'
import Carousel from './components/Carousel.vue'
import Information from './components/information/index.vue'
import { SupplierHeader } from '@/components/SupplierHeader'
import DetailInfo from './components/DetailInfo.vue'
import FactoryRecommend from './components/FactoryRecommend.vue'
import Summary from './components/Summary.vue'
import { OfferImagePreview } from './components/OfferImagePreview'
import { useProductDetail } from '../hooks/useProductDetail'
import { PageContainer } from '@/components/PageLayout'
import { useCalcShip } from '../hooks/useCalcShip'

const route = useRoute()
const router = useRouter()

const {
  detailInfo,
  showSkeleton,
  skuCartStatus,
  swiperImages,
  productImages,
  descriptionImages,
  variantImages,
  getDetailInfo,
  getSkuCartStatus
} = useProductDetail()
const { selectedSkuList } = useCalcShip()

const carouselRef = ref(null)

const containRef = ref()

const isProcessing = ref(false)

const infoRef = ref(null)

const offerId = computed(() => route.params.id)

const buriedEmail = () => {
  const { emailType = '', email_id: emailId = '', orderNo = '' } = route.query
  if (emailType) {
    buriedPointUtil({ eventId: 'PPD501', emailId: atob(emailId) })
    !!orderNo && waitForIntercom(orderNo)
  }
}

const handleUpdateCarousel = (index) => {
  carouselRef.value && carouselRef.value.slideToSkuImage(index)
}

const judgeProcessing = (skuId) => {
  isProcessing.value = skuCartStatus.value.includes(skuId)
}

const onAddCartSuccess = () => {
  getSkuCartStatus()
}

onBeforeMount(async () => {
  gaAnalytics('p_product_detail_page_view', 'p_product_detail_page_view', { spuId: offerId.value })
  buriedPointUtil({ eventId: 'PEX101', others: { offerIdList: [offerId.value] } })

  getDetailInfo()
  buriedEmail()
})

const onSearch = ({ text, supplierName }) => {
  if (!detailInfo.value) return
  router.push({
    name: 'factory',
    params: { name: supplierName ? formatName(supplierName) : '-', id: detailInfo.value.sellerOpenId },
    query: { keyword: text }
  })
}

const onFindSimilar = (image) => {
  sessionStorage.setItem(`currentMainImage_${offerId.value}`, image)
  openURLWithChannelQuery(`/search?offerId=${offerId.value}&type=similar`)
}
</script>

<style lang="less" scoped>
.product-content {
  .content-wrapper {
    padding-top: 24px;
    display: flex;
    gap: 24px;

    .content-wrapper-left {
      flex: 1;
      width: 0;

      .top {
        display: flex;
        gap: 24px;

        .carousel-wrapper {
          flex: 1;
          width: 0;
          max-width: 720PX;
        }
      }
    }
    .fixed-info {
      padding-bottom: 48px;
      width: 24%;
      min-width: 288px;
      max-width: 432PX;
    }
  }
}
</style>
